import formsBackendClient, { ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';
import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaire-templates/{creatorId}/{questionnaireTemplateId}/ai-agents']['GET'];
type Input = ThisApi['params'] & ThisApi['query'];

const getAiAgents = async ({ questionnaireTemplateId, creatorId, page, perPage }: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaire-templates/{creatorId}/{questionnaireTemplateId}/ai-agents', { creatorId, questionnaireTemplateId });
  const data = await formsBackendClient.get(path, { params: { page, perPage } });
  return data.data;
};

export default getAiAgents;